import React from "react";
import { Form, Input } from "antd";

import "./FormItemInputPassword.scss";

interface FormItemInputPasswordProps {
  name: string;
  placeholder?: string;
  label: string;
  rules: { required: boolean; message?: string };
  isSettings?: boolean;
}
const FormItemInputPassword: React.FC<FormItemInputPasswordProps> = ({
  name,
  rules,
  placeholder,
  label,
  isSettings,
}) => {
  return (
    <Form.Item
      className={`form-item__inputPassword ${isSettings ? "setting" : ""}`}
      name={name}
      label={label}
      rules={[{ required: rules.required, message: rules.message }]}
    >
      <Input.Password className={"input"} placeholder={placeholder} />
    </Form.Item>
  );
};

export default FormItemInputPassword;
